module.exports = __webpack_public_path__ + "img/04-3-4运维管理.31c290fc.svg";